import { Helmet } from 'react-helmet';

const SEO = ({ title, description, path = '' }) => {
  const siteName = 'Osaka Group';
  const baseUrl = 'https://osakagroup.com';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Where Every Journey Begins with Trust`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${baseUrl}${path}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${baseUrl}${path}`} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
